import { Component, OnInit } from "@angular/core";
import {
  DIAS_VIGENCIA_CERTIFICADO_SALDOS,
  ESTATUS_CARD_DATA,
  FAQ_CARD,
  RESPONSE_TRACKING,
} from "@constants/tramite-pension-constant";
import { IEstadoTramitePensionResponse } from "@interfaces/estado-tramite-pension.response.interface";
import { StorageService } from "@services/storage/storage.service";
import { IFaqItem } from "@shared/common/interfaces/faq-card.interface";
import { IEstatusCardDetail } from "@shared/common/interfaces/status-card.interface";
import { EstadoTramiteStepperService } from "../../services/estado-tramite-stepper.service";
import { Util } from "@shared/common/utils/util";
import { CertificadoSaldosService } from "../../services/certificado-saldos.service";
import { ModalController } from "@ionic/angular";
import { ModalDescargaCertificadoComponent } from "../../components/modal-descarga-certificado/modal-descarga-certificado.component";

@Component({
    selector: "app-certificado-saldos",
    templateUrl: "./certificado-saldos.component.html",
    standalone: false
})
export class CertificadoSaldosComponent implements OnInit {
  titleFaq: string = "";

  statusCardData = ESTATUS_CARD_DATA[1];

  faqCardData: IFaqItem[] = [];
  tieneCertificadoSaldos: boolean = false;
  private fechaInicioPendiente: string = '';
  private fechaVencimiento: string = '';
  loading = false;
  hasError = false;

  constructor(
    private readonly tramiteStepper: EstadoTramiteStepperService,
    private readonly storageService: StorageService,
    private readonly util: Util,
    private readonly certificadoSaldosService: CertificadoSaldosService,
    private readonly modalCtrl: ModalController
  ) { }

  async ngOnInit() {
    this.tramiteStepper.setStepCurrent(2);
    this.faqCardData = FAQ_CARD[1].questions[0].items;
    this.titleFaq = FAQ_CARD[1].questions[0].title;
    await this.getDataInfoTramite();
  }

  private async getDataInfoTramite(): Promise<void> {
    this.loading = true;
    this.hasError = false;

    try {
      const responseTracking: IEstadoTramitePensionResponse | null =
        await this.storageService.get(RESPONSE_TRACKING);

      const token = await this.util.getIdToken();
      const responseCertificados = await this.certificadoSaldosService.getCerfificadoSaldos(token);

      const fechaInicio =
        responseCertificados?.data?.datosCertificadoSaldo?.fechaInicioPendiente ?? null;

      if (fechaInicio) {
        this.fechaInicioPendiente = fechaInicio;
        this.fechaVencimiento = this.util.addDaysToDate(this.fechaInicioPendiente, DIAS_VIGENCIA_CERTIFICADO_SALDOS);
        this.tieneCertificadoSaldos = true;
      } else {
        this.tieneCertificadoSaldos = false;
      }

      this.statusCardData.details = this.buildDetails(this.tieneCertificadoSaldos);
      this.statusCardData.infoBoxMessage = responseTracking?.data?.resumen ?? '';

    } catch (error) {
      console.error('Error al obtener el certificado de saldos:', error);
      this.hasError = true;

      this.tieneCertificadoSaldos = false;
      this.statusCardData.details = this.buildDetails(false);
      this.statusCardData.infoText = 'En esta etapa puedes conocer tu Certificado de Saldos, con la información de tus ahorros, beneficiarios y promedio de renta.';
      this.statusCardData.requestTitle = 'Solicita tu Certificado de saldos';
      this.statusCardData.requestDescription = 'Puedes solicitar tu Certificado de Saldos mediante una';
      this.statusCardData.infoImportantInnerHTML = '';
    } finally {
      this.loading = false;
    }
  }

  private buildDetails(tieneCertificadoSaldo: boolean): IEstatusCardDetail[] {
    const common: IEstatusCardDetail[] = [
      {
        label: "Vigencia del documento",
        value: `${DIAS_VIGENCIA_CERTIFICADO_SALDOS} días corridos`,
        isHeader: false,
      },
      {
        label: "Solicita el Certificado de Saldos mediante",
        value: "Video Atención o Sucursal de AFP Capital",
        isHeader: false,
      },
    ];

    if (!tieneCertificadoSaldo) return common;

    return [
      {
        label: "Fecha de emisión del certificado",
        value: this.fechaInicioPendiente || '-',
        isHeader: false,
      },
      {
        label: "Fecha de vencimiento del certificado",
        value: this.fechaVencimiento || '-',
        isHeader: false,
      },
      {
        label: "Vigencia del documento",
        value: `${DIAS_VIGENCIA_CERTIFICADO_SALDOS} días corridos`,
        isHeader: false,
      }
    ];
  }

  async goToModalDescargaCertificado() {

    const modal = await this.modalCtrl.create({
      component: ModalDescargaCertificadoComponent,
      cssClass: "modal-descarga-certificado",
    });
    await modal.present();

  }
}
